import { configureStore } from "@reduxjs/toolkit";
import auditReducer from "./slices/auditSlice";
import reportReducer from "./slices/reportSlice";
import geminiReducer from "./slices/geminiSlice";

export const store = configureStore({
  reducer: {
    audit: auditReducer,
    report: reportReducer,
    gemini: geminiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

// Remove TypeScript syntax from JavaScript file
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
